/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { FrontendFieldDefinitionType } from './FrontendFieldDefinitionType';
import type { VehicleTypeModeSelection } from './VehicleTypeModeSelection';
import type { VehicleMakeModelSelectItem } from './VehicleMakeModelSelectItem';
import type { FieldTranslations } from './FieldTranslations';
import type { SelectValueItem } from './SelectValueItem';
import type { ShowConditions } from './ShowConditions';
import type { ImageSubject } from './ImageSubject';
import type { StructuredAddressFieldResponse } from './StructuredAddressFieldResponse';

export interface FieldResponse {
    name: string;
    type: FrontendFieldDefinitionType;
    current_value: any | null;
    is_required: boolean;
    translations: FieldTranslations;
    show_if?: ShowConditions;
    is_expiry_required?: boolean;
    document_type_key?: string;
    document_type_example_url?: string | null;
    document_decline_reason_title?: string;
    document_decline_reason_action_item?: string;
    default_value?: any | null;
    select_values?: Array<SelectValueItem>;
    is_searchable?: boolean;
    min_length?: number;
    max_length?: number;
    min_value?: number;
    max_value?: number;
    generic_field_key?: string;
    vehicle_type_mode?: VehicleTypeModeSelection;
    regex?: string;
    image_subject?: ImageSubject;
    structured_address_config?: Array<StructuredAddressFieldResponse>;
    current_manufacturer_id?: number | null;
    manufacturer_list?: Array<VehicleMakeModelSelectItem>;
}
